import * as React from "react";
import axios from 'axios';
import ContextService from "../../services/ContextService";
// import { useAuth } from "../../services/AuthContext";

// const { token, currentUser } = useAuth()

interface IpropsGetAllDisplayFieldName{
    setNewDocDisplayFields?: React.Dispatch<React.SetStateAction<{}>>
    Refresh?:boolean;
}

interface IpropsGetAllBusinessUnitName{
    setNewContractName?: React.Dispatch<React.SetStateAction<{}>>
    Refresh?:boolean;
}


// let GlobalData={}
// let Data=false
// const fetcher=()=>{
//   return  ContextService.GetSPContext()
//     .get(
//         `${ContextService.GetUrl()}/_api/web/lists/getbytitle('CLM365Contract_Type')/items?$select=ID,Guid_ID,ContractName,ContractCode`,
//         SPHttpClient.configurations.v1,
//         {
//             headers: {
//                 Accept: "application/json;odata=nometadata",
//                 "odata-version": "",
//             }
//         }
//     )
//     .then((response: SPHttpClientResponse) => {
//         if (response.ok) {
//             //  setEnableShimmer(false);
//         }
//         return response.json();
//     })
//     .then((items: any) => {
//      GlobalData={};
//         if (items.value.length > 0) {  
//             items.value?.map((curr, index) => {
//                     GlobalData[curr.Guid_ID]=curr.ContractName;
//                     Data=true
//                 })
//                 return GlobalData
//             }
        
//       })

// }
let globalDataTemp=[]
// let GlobalData={}
// let Data=false

const fetcher = async (refresh: boolean): Promise<any[]> => {
    const token = localStorage.getItem("CurrentToken");
    // If global data is available and no refresh is requested, return the cached data
    if (globalDataTemp.length && !refresh) {
        return globalDataTemp;
    }

    try {
        const SiteURL=localStorage.getItem("SiteURL")||"";
        // Define the SharePoint API endpoint
        const apiUrl = `${SiteURL}/_api/web/lists/getbytitle('CLM365Contract_Type')/items`;

        // Define query parameters for the API
        const params = {
            $select: 'ID,Guid_ID,BusinessUnit,ContractName,ContractCode,BusinessUser/Id,BusinessUser/Title',
            $expand: 'BusinessUser',
        };

        // Make the HTTP GET request using axios
        const response = await axios.get(apiUrl, {
            headers: {
                Accept: 'application/json;odata=nometadata',
                'odata-version': '',
                Authorization: `Bearer ${token}`, // Use token for authentication
            },
            params,
        });
 
        // Extract data from the response
        const items = response.data?.value || [];
        globalDataTemp = items; // Cache the data
        return items;
    } catch (error) {
        console.error('Error fetching data:', error);
     
        throw error; // Re-throw error for handling in the calling function
    }
};

export  function GetAllContractTypeName({
    setNewContractName=(_val)=>{},
    Refresh=false
}:IpropsGetAllBusinessUnitName)
{

return fetcher(Refresh).then(c=>{
   const  GlobalData={};
   //console.log(c,"cccc");
            if (c.length > 0) {
                // if (c[0].BusinessUnit != null) {
                //     const businessunitArray = JSON.parse(c[0]?.BusinessUnit);
                    c?.map((curr, index) => {
                        GlobalData[curr.Guid_ID]=curr.ContractName;
                    })
                  //  return GlobalData
               // }
            }
            ////console.log(GlobalData,"GlobalData");
            setNewContractName({...GlobalData});
                return GlobalData


})
}
export async function GetAllContractTypeOptions({
    setNewContractName=(_val)=>{},
    Refresh=false
}:IpropsGetAllBusinessUnitName)
{
   
 
return fetcher(Refresh).then(c=>{
 const   GlobalData={};
 const   GlobalData1=[];
            if (c.length > 0) {
                //if (c[0].BusinessUnit != null) {
                  //  const businessunitArray = JSON.parse(c[0]?.BusinessUnit);
                    c?.map((curr, index) => {
                        let f1={
                            key: curr.Guid_ID, text: curr.ContractName,code:curr.ContractCode, label:curr.ContractName, value:curr.ContractName
                        }
                        GlobalData1.push(f1) // GlobalData[curr.GUID]=curr.Name;
                    })
                //}
            }
           // setNewBusinessUnit(Object.entries(GlobalData)?.map(([key1, column]: any, index) =>    ({ key: key1, text: column })))
           setNewContractName(GlobalData1) 
        return  GlobalData1//  Object.entries(GlobalData)?.map(([key1, column]: any, index) =>    ({ key: key1, text: column  }))
})
}
// export  function GetAllContractTypeName({
//     setNewContractName=(_val)=>{},
//     Refresh=false
// }:IpropsGetAllBusinessUnitName)
// {
//     if (Data && !Refresh){
//         ////console.log("inside if")
//     setNewContractName(GlobalData);
//  return   
// }
// return fetcher().then(c=>{
//                 setNewContractName(c);


// })
// }
// export async function GetAllContractTypeOptions({
//     setNewContractName=(_val)=>{},
//     Refresh=false
// }:IpropsGetAllBusinessUnitName)
// {
   
//     if (Data && !Refresh){
//     setNewContractName( Object.entries(GlobalData)?.map(([key1, column]: any, index) =>    ({ key: key1, text: column })
//                 ));
//  return   Object.entries(GlobalData)?.map(([key1, column]: any, index) =>    ({ key: key1, text: column }))
// }
// return fetcher().then(c=>{
//     setNewContractName(Object.entries(c)?.map(([key1, column]: any, index) =>    ({ key: key1, text: column })))
//    return Object.entries(c)?.map(([key1, column]: any, index) =>    ({ key: key1, text: column }))
// })

// //   await  ContextService.GetSPContext()
// //     .get(
// //         `${ContextService.GetUrl()}/_api/web/lists/getbytitle('CLM365General')/items?$select=ID,BusinessUnit,Modified`,
// //         SPHttpClient.configurations.v1,
// //         {
// //             headers: {
// //                 Accept: "application/json;odata=nometadata",
// //                 "odata-version": "",
// //             }
// //         }
// //     )
// //     .then((response: SPHttpClientResponse) => {
// //         if (response.ok) {
// //             //  setEnableShimmer(false);
// //         }
// //         return response.json();
// //     })
// //     .then((items: any) => {
// //      GlobalData={};
// //         if (items.value.length > 0) {
// //             if (items.value[0].BusinessUnit != null) {
// //                 const businessunitArray = JSON.parse(items.value[0]?.BusinessUnit);
// //                 businessunitArray.map((curr, index) => {
// //                     GlobalData[curr.GUID]=curr.Name;
// //                     Data=true
// //                 })
// //                 setNewContractName( Object.entries(GlobalData)?.map(([key1, column]: any, index) =>    ({ key: key1, text: column })
// //                 ));
// //                 // setNewContractName(GlobalData);
// //             }
// //         }
// //       })
// }

export  function GetAllContractTypeNameHome({
    setNewContractName=(_val)=>{},
    Refresh=false
}:IpropsGetAllBusinessUnitName)
{

// return fetcher().then(c=>{
//   // const  GlobalData={};
//             // if (c.length > 0) {
//             //     if (c[0].BusinessUnit != null) {
//             //         const businessunitArray = JSON.parse(c[0]?.BusinessUnit);
//             //         businessunitArray.map((curr, index) => {
//             //             GlobalData[curr.GUID]=curr.Name;
//             //         })
//             //       //  return GlobalData
//             //     }
//             // }
//             // //////console.log(GlobalData,"GlobalData");
//                 setNewContractName({...GlobalData});
//                 return GlobalData


// })
return fetcher(Refresh).then(c=>{
    const  GlobalData={};
    //console.log(c,"cccc");
             if (c.length > 0) {
                 // if (c[0].BusinessUnit != null) {
                 //     const businessunitArray = JSON.parse(c[0]?.BusinessUnit);
                     c?.map((curr, index) => {
                         GlobalData[curr.Guid_ID]=curr.ContractName;
                     })
                   //  return GlobalData
                // }
             }
             ////console.log(GlobalData,"GlobalData");
             setNewContractName({...GlobalData});
                 return GlobalData

})
}



export async function GetAllContractTypeBusinessUsers({
    setNewContractName=(_val)=>{},
    Refresh=false
}:IpropsGetAllBusinessUnitName)
{
   
 
return fetcher(Refresh).then(c=>{
 const   GlobalData={};
 const   GlobalData1=[];
            if (c.length > 0) {
                
                    c?.map((curr, index) => {
                        let busUsers=curr?.BusinessUser?.map((i)=>i?.Id)
                        let f1={
                           Id:curr.ID, Guid_ID: curr.Guid_ID, BusinessUsers: busUsers, text: curr.ContractName,BusinessUnit:curr.BusinessUnit
                        }
                        GlobalData1.push(f1) 
                    })
               
            }
          
           setNewContractName(GlobalData1) 
        return  GlobalData1
})
}


let GlobalDatasTemp=[]
// let GlobalData={}
// let Data=false
const fetcherFields=async(Refresh:boolean)=>{
    ////console.log(GlobalDataTemp,"GlobalDataTemp");
    const token = localStorage.getItem("CurrentToken");
    const SiteURL = localStorage.getItem("SiteURL");
    if (GlobalDatasTemp.length &&!Refresh)
    {
        return GlobalDatasTemp
    }
    try{
        const response=await axios
        .get(
          `${SiteURL}` +
          `/_api/web/lists/getbytitle('CLM365DocumentAttachment')/Fields?$select=*&$filter=ReadOnlyField eq false`,
        
          {
            headers: {
              Accept: "application/json;odata=nometadata",
              "odata-version": "",
              Authorization: `Bearer ${token}`, 
            }
          }
        )
      
            const fields = response?.data;
      
            // Cache the fetched data to GlobalDatasTemp
            GlobalDatasTemp = fields?.value || [];
      
            // Return the fields
            return fields?.value || [];
    }catch(error){
        console.log(error)
        return []


    }
 

}

export  function GetAllDocDisplayFieldName({
    setNewDocDisplayFields=(_val)=>{},
    Refresh=false
}:IpropsGetAllDisplayFieldName)
{
return fetcherFields(Refresh).then(c=>{
   const  GlobalData={};
  //  console.log(c,"cccc")
            if (c.length > 0) {
               
                c?.map((templ: any) => {
                   
                   // if (!['Title', 'Contract_Start_Date', 'Guid_ID', 'Counterparty_Name', 'Attachments', 'Status', 'Business_Unit', 'MetaInfo', 'PropertyBag', 'FileLeafRef', 'Order', 'Contract_End_Date', 'Contract_Term', "Contract_Type", "ContentType", "Draft_Type", "Contract_Date", "Priority", "Request_Number", "Request_Type", "File_Name", "Approval_Infos", "Activity_Log", "AllTaskApprovers", "Legal_User", "Remarks", "ActualFileName", "Contract", "RequestApproval", "DraftApproval", "ExecutionApproval", "Negotiation", "ApprovalStage","SOW_Details"].includes(templ.InternalName)) {
                        //console.log(templ.Title,"templ.Title",templ.InternalName);
                        GlobalData[templ.InternalName]=(templ.Title).replaceAll('_', ' ');
                   // }
                })
            }
            ////console.log(GlobalData,"GlobalData");
            setNewDocDisplayFields({...GlobalData});
                return GlobalData
})
}